<template>
    <section>
        <div class="text-container valign">
            <h3 class="text-title__big">ТЕСТ НА BBQ</h3>
            <div class="text-main">
                <p>Планируете провести выходные с шампуром в руке? Ждете&nbsp;вечер&nbsp;пятницы, чтобы отправиться на дачу и жарить&nbsp;там&nbsp;стейки до воскресенья?
                Неплохой план, однако&nbsp;к&nbsp;нему&nbsp;стоит подготовиться заранее, чтобы ваш организм&nbsp;не&nbsp;испытал белковую (и не только) перегрузку.
                Узнайте&nbsp;о&nbsp;том, какие рецепты вам подойдут, а также
                о&nbsp;мерах,&nbsp;которые стоит принять, если мяса окажется<br class="mobile-hidden"> слишком много.</p>
            </div>
            <router-link to="/" class="btn btn-hover" @click.native = "gaClickNext"><span>далее</span></router-link>
        </div>
        <div class="decoration-container decoration-container__main">
            <div class="layer layer__1" :style="{transform: 'rotate(-'+angle+'deg)'}">
                <transition name="fade-left-top" appear>
                  <div class="circle"></div>
                </transition>
                <transition name="fade-left-bottom" appear>
                  <div class="circle"></div>
                </transition>
                <transition name="fade-right-top" appear>
                  <div class="circle"></div>
                </transition>
                <transition name="fade-right-bottom" appear>
                  <div class="circle"></div>
                </transition>
            </div>
            <div class="layer layer__2" :style="{transform: 'rotate('+angle+'deg)'}">
              <transition name="fade-left-top" appear>
                <img class="i-1" src="/static/images/grill.png" alt="Grill">
              </transition>
              <transition name="fade-left-bottom" appear>
                <img class="i-2" src="/static/images/item-2.png" alt="Item">
              </transition>
              <transition name="fade-left-bottom" appear>
                <img class="i-3" src="/static/images/item-3-1.png" alt="Item">
              </transition>
              <transition name="fade-right-top" appear>
                <img class="i-4" src="/static/images/item-1.png" alt="Item">
              </transition>
              <transition name="fade-right-top" appear>
                <img class="i-5" src="/static/images/item-4-2.png" alt="Item">
              </transition>
              <transition name="fade-right-bottom" appear>
                  <img class="i-6" src="/static/images/item-5.png" alt="Item">
              </transition>

              <transition name="fade-right-bottom" appear>
                  <img class="i-7" src="/static/images/item-6.png" alt="Item">
              </transition>
              <transition name="fade-right-bottom" appear>
                  <img class="i-8" src="/static/images/item-7.png" alt="Item">
              </transition>
            </div>
        </div>
    </section>
</template>

<script>
    import {TweenMax} from 'gsap';

    export default {
        name: 'Page1',
        methods: {
            gaClickNext(){
                ga('send', 'event', 'click', 'show', 'Home page click Next');
            }
        },
        data () {
            return {
                angle: 0
            }
        },
        mounted(){
            let self = this;
            document.body.addEventListener('mousemove',function(e){
                self.angle = (e.clientX+e.clientY)/1000;
            })
        },
    }
</script>
<style>
  .fade-left-top-enter-active, .fade-left-top-leave-active {
    transition: .5s opacity .5s, .5s transform .5s;
  }
  .fade-left-top-enter, .fade-left-top-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
    transform: translate3d(50%,50%,0);
  }


  .fade-left-bottom-enter-active, .fade-left-bottom-leave-active {
    transition: .5s opacity .5s, .5s transform .5s;
  }
  .fade-left-bottom-enter, .fade-left-bottom-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
    transform: translate3d(50%,-50,0%);
  }


  .fade-right-top-enter-active, .fade-right-top-leave-active {
    transition: .5s opacity .5s, .5s transform .5s;
  }
  .fade-right-top-enter, .fade-right-top-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
    transform: translate3d(-50%,50%,0);
  }


  .fade-right-bottom-enter-active, .fade-right-bottom-leave-active {
    transition: .5s opacity .5s, .5s transform .5s;
  }
  .fade-right-bottom-enter, .fade-right-bottom-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
    transform: translate3d(-50%,-50%,0);
  }
</style>



// WEBPACK FOOTER //
// Index.vue?1a9501e0